import API from '@/lib/API.js'
import comun from './comun.js'
const empresasafiliados = {
    namespaced: true,
    state: {
        Lista: [],
        Seleccionado: undefined
    },
    mutations: {
        init(state) {
            state = {
                Lista: [],
                Seleccionado: undefined
            };
        },
        set(state, valor) {
            state.Lista = valor;
        },
        agregar(state, valor) {
            state.Lista.push(valor);
        },
        select(state, valor) {
            state.Seleccionado = valor;
        },
    },
    actions: {
        async traerPorEmpresa({
            commit
        }, valor) {
            commit("comun/cargando")
            let data = []
            data = await API.Empresas_Afiliados.traerPorEmpresa(valor);
            commit("set", data)
            commit("comun/fincarga")
        },
        async traerPorAfiliado({
            commit
        }, valor) {
            commit("comun/cargando")
            let data = []
            data = await API.Empresas_Afiliados.traerPorAfiliado(valor);
            commit("set", data)
            commit("comun/fincarga")
        },
        select({
            commit
        }, valor) {
            commit("select", valor)
            commit("set", [])
        },
        async modificarSeleccionada({
            commit,
            state
        }) {
            try {
                let data = []
                let str = ""
                if (state.Seleccionado.id_empresa != 0) {
                    data = await API.Empresas_Afiliados.modificar(state.Seleccionado);
                    str += "dato modificado"
                } else {
                    data = await API.Empresas_Afiliados.alta(state.Seleccionado);
                    commit("agregar", data)
                    str += `Empleado ingresado a la empresa`
                }
                commit("select", data)
                commit("comun/mostrar", str)

            } catch (error) {
                alert(error)
            }
        },
        async modificarEntidad({
            commit,
            state
        }, entidad) {
            try {
                let str = ""
                if (entidad.id_empresas_afiliados != 0) {
                    entidad = await API.Empresas_Afiliados.modificar(entidad);
                    str += "dato modificado"
                } else {

                    let data = await API.Empresas_Afiliados.alta(entidad);
                    commit("agregar", data)
                    str += `Empleado ingresado a la empresa`
                }
                commit("comun/mostrar", str)
                return 0;
            } catch (error) {
                alert(error)
            }
        },
    },
    modules: {
        comun,
    }

}
export default empresasafiliados;